import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const FONTS = `@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Syne:wght@700;800&display=swap');*{box-sizing:border-box}`;

export function SidebarLayout({ navItems, title, subtitle, children }) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { signOut(); navigate('/login'); };

  const Sidebar = () => (
    <div style={{ display:'flex',flexDirection:'column',height:'100%' }}>
      {/* Logo */}
      <div style={{ padding:'26px 18px 18px',borderBottom:'1px solid rgba(255,255,255,0.07)' }}>
        <div style={{ display:'flex',alignItems:'center',gap:12 }}>
          <div style={{ width:40,height:40,background:'linear-gradient(135deg,#7c3aed,#4f46e5)',borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,flexShrink:0 }}>🏪</div>
          <div>
            <div style={{ color:'#fff',fontWeight:700,fontSize:15,fontFamily:"'Syne',sans-serif",lineHeight:1.1 }}>{title}</div>
            <div style={{ color:'rgba(255,255,255,0.35)',fontSize:11,marginTop:2 }}>{subtitle}</div>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav style={{ flex:1,padding:'14px 10px',display:'flex',flexDirection:'column',gap:3 }}>
        {navItems.map(n => (
          <NavLink key={n.to} to={n.to} end={!!n.end}
            onClick={() => setOpen(false)}
            style={({ isActive }) => ({
              display:'flex',alignItems:'center',gap:11,
              padding:'10px 12px',borderRadius:10,textDecoration:'none',
              fontSize:14,fontWeight:500,transition:'all 0.14s',
              color: isActive ? '#fff' : 'rgba(255,255,255,0.48)',
              background: isActive ? 'rgba(124,58,237,0.22)' : 'transparent',
              border: `1px solid ${isActive ? 'rgba(124,58,237,0.3)' : 'transparent'}`,
            })}>
            <span style={{ fontSize:17,width:22,textAlign:'center' }}>{n.icon}</span>
            {n.label}
          </NavLink>
        ))}
      </nav>

      {/* User + logout */}
      <div style={{ padding:'12px 10px',borderTop:'1px solid rgba(255,255,255,0.07)' }}>
        <div style={{ padding:'10px 12px',marginBottom:8,borderRadius:10,background:'rgba(255,255,255,0.04)' }}>
          <div style={{ color:'#fff',fontSize:13,fontWeight:600 }}>{user?.username}</div>
          <div style={{ color:'rgba(255,255,255,0.3)',fontSize:11 }}>{user?.role === 'superadmin' ? 'Super Admin' : 'Mi Panel'}</div>
        </div>
        <button onClick={handleLogout} style={{
          width:'100%',padding:'9px 12px',
          background:'rgba(239,68,68,0.1)',border:'1px solid rgba(239,68,68,0.2)',
          borderRadius:10,color:'#fca5a5',fontSize:13,fontWeight:500,
          cursor:'pointer',textAlign:'left',fontFamily:'inherit',
          display:'flex',alignItems:'center',gap:8,
        }}>
          🚪 Cerrar sesión
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ display:'flex',minHeight:'100vh',background:'#0d0d1a',fontFamily:"'DM Sans',sans-serif" }}>
      <style>{FONTS}</style>

      {/* Desktop sidebar */}
      <aside className="sidebar-desktop" style={{
        width:230,flexShrink:0,
        background:'rgba(255,255,255,0.03)',
        borderRight:'1px solid rgba(255,255,255,0.07)',
        position:'sticky',top:0,height:'100vh',
      }}>
        <Sidebar />
      </aside>

      {/* Mobile overlay */}
      {open && (
        <div style={{ position:'fixed',inset:0,zIndex:500 }}>
          <div onClick={() => setOpen(false)} style={{ position:'absolute',inset:0,background:'rgba(0,0,0,0.65)' }} />
          <aside style={{ position:'absolute',left:0,top:0,bottom:0,width:230,background:'#12122a',borderRight:'1px solid rgba(255,255,255,0.08)',zIndex:1 }}>
            <Sidebar />
          </aside>
        </div>
      )}

      {/* Main content */}
      <div style={{ flex:1,display:'flex',flexDirection:'column',minWidth:0 }}>
        {/* Mobile header */}
        <header className="mobile-header" style={{
          padding:'13px 18px',borderBottom:'1px solid rgba(255,255,255,0.07)',
          display:'flex',alignItems:'center',gap:12,
          background:'rgba(255,255,255,0.02)',
        }}>
          <button onClick={() => setOpen(true)} style={{ background:'rgba(255,255,255,0.08)',border:'none',borderRadius:8,width:36,height:36,color:'#fff',cursor:'pointer',fontSize:18,display:'flex',alignItems:'center',justifyContent:'center' }}>
            ☰
          </button>
          <span style={{ color:'#fff',fontWeight:700,fontFamily:"'Syne',sans-serif",fontSize:16 }}>{title}</span>
        </header>

        <main style={{ flex:1,padding:'24px 20px',overflowX:'hidden' }}>
          {children}
        </main>
      </div>

      <style>{`
        .sidebar-desktop { display: flex !important; flex-direction: column; }
        .mobile-header { display: none !important; }
        @media (max-width: 767px) {
          .sidebar-desktop { display: none !important; }
          .mobile-header { display: flex !important; }
        }
      `}</style>
    </div>
  );
}
